// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm } from "../../../components/isRequired";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack, BiPrinter } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import Skeltons from "../../../components/loading/Skeltons";
import { Currency, Top } from "../purchase-requisition/configuration";
import DatePicker from "react-datepicker";
import { ChangeToString } from "../../../components/form/ObjectChanger";

const PreviewPurchaseComparationPage = ({}) => {
  let initialState = {
    SupplierCount: 0,
    BisnisUnitID: "U0002",
  };

  const validations = [
    ({ UserPCName }) =>
      isRequired(UserPCName) || { UserPCName: "Nama UserPC wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
    ({ KelompokID }) =>
      isRequired(KelompokID) || { KelompokID: "Kelompok wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Kelompok wajib diisi" },
    ({ DetailAccountID }) =>
      isRequired(DetailAccountID) || {
        DetailAccountID: "Detail Account wajib diisi",
      },
    ({ Status }) =>
      isRequired(Status) || { Status: "Detail Account wajib diisi" },
  ];

  const { values, touched, customHandler, changeHandler, errors, editHandler } =
    useForm(initialState, validations);

  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const supplier = useMutation((formData) => fetchGet("Master/Supplier/min"));

  const [prData, setPRData] = useState([]);
  const [barang, setBarang] = useState([]);
  const [pRListComparison, setPRListComparison] = useState([]);
  const [showDetail, setshowDetail] = useState(true);
  const [generalTotal, setGeneralTotal] = useState(0);

  const barangDetail = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [supplierSelected, setSupplierSelected] = useState(1);

  const ModalOpener = (detail) => {
    setShowModal(true);
  };
  const mutationAdd = useMutation((formData) =>
    fetchPost("Procurement/PriceComparison/approval/send", formData)
  );
  const mutationSave = useMutation((formData) =>
    fetchPost("Procurement/PriceComparison", formData)
  );

  const PurchaseRequisition = useMutation((formData) =>
    fetchPost("Procurement/PurchaseRequisition/min", formData)
  );
  const PurchaseRequisitionDetail = useMutation((formData) =>
    fetchGet("Procurement/PurchaseRequisitionStockOnly/" + formData)
  );
  const franco = useMutation((formData) => fetchGet("Master/Franco/min"));
  const PriceComparison = useMutation((formData) =>
    fetchGet("Procurement/PriceComparisonMon/" + formData)
  );
  const param = useLocation();
  const params = useParams();

  const mutationUpdate = useMutation((formData) =>
    fetchPost("Procurement/PriceComparison/approval/update", formData)
  );

  const navigate = useNavigate();

  useEffect(() => {
    supplier.mutate();

    barangDetail.mutate();
    PurchaseRequisition.mutate({ BisnisUnitID: params.id });
    franco.mutate();
    if (params.transid) {
      PriceComparison.mutate(params.transid.replaceAll("-", "/"));
    }
  }, []);

  useEffect(() => {
    if (prData && params.transid) {
      const index = prData.findIndex(
        (x) => x.PurchaseRequisitionID === params.msr.replaceAll("-", "/")
      );
      customHandler(index, "PurchaseRequisitionID");
    }
    if (params.msr) {
      PurchaseRequisitionDetail.mutate(params.msr);
    }
  }, [prData]);

  useEffect(() => {
    if (mutationUpdate) {
      if (mutationUpdate.isSuccess) {
        navigate("/approval-list");
      }
    }
  }, [mutationUpdate.status]);

  useEffect(() => {
    if (PurchaseRequisitionDetail.data) {
      setBarang(PurchaseRequisitionDetail.data.data.PRList);
    }
  }, [PurchaseRequisitionDetail.data]);

  useEffect(() => {
    if (PriceComparison.data) {
      const tempArray = PriceComparison.data.data;
      if (tempArray && tempArray[0]["PurchaseRequisitionID"]) {
        customHandler(tempArray.length, "SupplierCount");

        for (let selected = 0; selected < tempArray.length; selected++) {
          if (tempArray[selected]["PRListComparison"]) {
            // Urutan tetap per PRListID supaya baris antar supplier sejajar
            tempArray[selected]["PRListComparison"].sort(
              (a, b) => Number(a.PRListID) - Number(b.PRListID)
            );
            // Hitung total harga per item
            for (
              let i = 0;
              i < tempArray[selected]["PRListComparison"].length;
              i++
            ) {
              // Gabungkan data berdasarkan PRListID, BUKAN urutan baris: harga
              // dari backend tak berurutan & daftar MSR bisa memuat barang yang
              // tak ada di PC, sehingga pasangan per indeks menampilkan harga di
              // samping barang yang salah (kasus 01736/PC/SO/09/2026).
              const prRow = (PurchaseRequisitionDetail.data.data.PRList || []).find(
                (p) => String(p.PRListID) === String(tempArray[selected]["PRListComparison"][i]["PRListID"])
              );
              tempArray[selected]["PRListComparison"][i] = {
                ...tempArray[selected]["PRListComparison"][i],
                ...(prRow || {}),
              };

              // Hitung TotalHarga per item
              tempArray[selected]["PRListComparison"][i]["TotalHarga"] =
                tempArray[selected]["PRListComparison"][i]["Harga"] *
                tempArray[selected]["PRListComparison"][i]["Qty"];
            }

            // Hitung SUBTOTAL (sebelum discount)
            let subtotal = 0;
            for (
              let j = 0;
              j < tempArray[selected]["PRListComparison"].length;
              j++
            ) {
              if (tempArray[selected]["PRListComparison"][j]["TotalHarga"]) {
                subtotal += parseFloat(
                  tempArray[selected]["PRListComparison"][j]["TotalHarga"] || 0
                );
              }
            }
            tempArray[selected]["Total"] = subtotal; // Simpan subtotal

            // Hitung DISCOUNT AMOUNT
            let discountAmount = 0;
            const discountPercent = parseFloat(
              tempArray[selected]["DiscountPercent"] || 0
            );
            const discountRupiah = parseFloat(
              tempArray[selected]["DiscountRupiah"] || 0
            );

            if (discountPercent > 0) {
              // Jika ada discount persentase
              discountAmount = (subtotal * discountPercent) / 100;
            } else if (discountRupiah > 0) {
              // Jika ada discount rupiah
              discountAmount = discountRupiah;
            }

            // Hitung TOTAL SETELAH DISCOUNT
            const totalAfterDiscount = subtotal - discountAmount;

            // **SESUAI PERMINTAAN ANDA: TUKAR POSISI**
            // Total2 = nilai discount
            // Discound = nilai setelah discount
            tempArray[selected]["Discount"] = discountAmount; // nilai discount
            tempArray[selected]["GrandTotal"] = totalAfterDiscount; // nilai setelah discount

            // Hitung PAJAK (berdasarkan totalAfterDiscount)
            let PPNTotal = 0;
            let PPHTotal = 0;
            let PBBKBTotal = 0;

            const ppnPercent = parseFloat(tempArray[selected]["PPN"] || 0);
            const pphPercent = parseFloat(tempArray[selected]["PPH"] || 0);
            const pbbkbPercent = parseFloat(tempArray[selected]["PBBKB"] || 0);

            if (ppnPercent > 0) {
              PPNTotal = (totalAfterDiscount * ppnPercent) / 100;
            }
            if (pphPercent > 0) {
              PPHTotal = (totalAfterDiscount * pphPercent) / 100;
            }
            if (pbbkbPercent > 0) {
              PBBKBTotal = (totalAfterDiscount * pbbkbPercent) / 100;
            }

            tempArray[selected]["PPNTotal"] = PPNTotal;
            tempArray[selected]["PPHTotal"] = PPHTotal;
            tempArray[selected]["PBBKBTotal"] = PBBKBTotal;

            // Hitung GRAND TOTAL FINAL
            // Biaya Lain-lain: di LUAR biaya utama, setelah pajak.
            const biayaLain = Math.max(0, parseFloat(tempArray[selected]["BiayaLain"] || 0) || 0);
            const grandTotal =
              totalAfterDiscount + PPNTotal - PPHTotal + PBBKBTotal + biayaLain;
            tempArray[selected]["GTOTAL"] = grandTotal;

            // Update general total
            setGeneralTotal((prev) => prev + grandTotal);
          }
        }

        setPRListComparison(tempArray);
      }
    }
  }, [barang]);

  useEffect(() => {
    var tempArray = [];
    if (PurchaseRequisition.data) {
      if (PurchaseRequisition.data.data) {
        PurchaseRequisition.data.data.map((datas, i) => {
          tempArray.push({
            ...datas,
            value: i,
            label: datas.PurchaseRequisitionID,
          });
        });
      }
    }
    setPRData(tempArray);
  }, [PurchaseRequisition.data]);

  let user = JSON.parse(localStorage.getItem("user"));

  const getDataFromURL = (url) =>
    new Promise((resolve, reject) => {
      url = url.replaceAll("/", "-");
      setTimeout(() => {
        fetch(process.env.REACT_APP_API_UPLOAD_URL + "file/" + url, {
          method: "GET", // or 'PUT'
        })
          .then((response) => response.blob())
          .then((data) => {
            const file = window.URL.createObjectURL(data);
            window.open(file);
          });
      });
    }, 2000);

  // Nama satuan diambil dari master barang yang sudah dimuat halaman ini
  // (Master/Barang/min). PRListComparison dari API TIDAK membawa NamaSatuan,
  // jadi tabel perbandingan supplier di bawah harus melihat ke sini juga.
  // Mengembalikan "" bila master belum termuat — angkanya tetap tampil.
  const satuanBarang = (barangID) =>
    barangDetail.data?.data?.find(({ value }) => value === barangID)
      ?.NamaSatuan || "";

  const header = [
    { name: "Barang", key: "BarangID", modifiers: "Barang" },
    { name: "Qty", key: "Qty", modifiers: "QtySatuan" },
    { name: "SDT Date", key: "SDTDate", modifiers: "dateOnlyNew" },
    { name: "Specification", key: "Specification", modifiers: "Text" },
  ];

  const PRHandler = (value, names) => {
    customHandler(value, names);
    PurchaseRequisitionDetail.mutate(prData[value]["PurchaseRequisitionID"].replaceAll("/", "-"));
  };

  const SupplierCount = (e) => {
    changeHandler(e);
    let detailArray = [];
    if (PurchaseRequisitionDetail.data) {
      PurchaseRequisitionDetail.data.data.PRList.map((detail, i) => {
        detailArray.push({
          ...detail,
          Harga: 0,
          DiscountPercent: 0,
          DiscountRupiah: 0,
          Merk: "",
          PilihanBeli: false,
        });
      });
    }
    if (e.target.value && e.target.value > 0) {
      let TempArray = [];
      for (let i = 1; i <= e.target.value; i++) {
        const obj = {
          TanggalKirim: new Date(),
          PPN: 0,
          PPH: 0,
          PBBKB: 0,
          PRListComparison: detailArray,
        };
        TempArray.push(obj);
      }
      if (PurchaseRequisitionDetail.data) {
        setPRListComparison(TempArray);
      }
    }
  };

  const PurchaseRequisitionDetailEditor = (ids, i, e, len) => {
    let tempArray = JSON.parse(JSON.stringify(pRListComparison));
    const selected = ids;
    let valuesTarget = e.target.value;
    if (e.target.name === "PilihanBeli") {
      valuesTarget = e.target.checked;
    }

    for (let j = 0; j < pRListComparison.length; j++) {
      if (valuesTarget) {
        tempArray[j]["PRListComparison"][i][e.target.name] = false;
      }
    }
    tempArray[selected]["PRListComparison"][i][e.target.name] = valuesTarget;

    setPRListComparison([...tempArray]);
  };

  const SupplierBuilder = () => {
    let returnArray = [];
    if (values.SupplierCount && values.SupplierCount > 0) {
      for (let i = 1; i <= values.SupplierCount; i++) {
        returnArray.push(
          <li key={i} className="mr-2" role="presentation">
            <button
              onClick={() => {
                setSupplierSelected(i);
              }}
              className={
                supplierSelected === i
                  ? "inline-block p-4 rounded-t-lg border-b-2 text-main-100 border-main-100 bg-gray-200"
                  : "inline-block p-4 rounded-t-lg border-b-2 "
              }
              type="button"
              role="tab"
              aria-selected="false"
            >
              Detail Supplier - {i}
            </button>
          </li>
        );
      }
    }
    return returnArray;
  };

  const Kirim = (type) => {
    let newValues = [];
    if (values.SupplierCount && values.SupplierCount > 0) {
      for (let i = 0; i < values.SupplierCount; i++) {
        let obj = ChangeToString(pRListComparison[i]);
        for (let j = 0; j < obj["PRListComparison"].length; j++) {
          obj["PRListComparison"][j] = ChangeToString(
            obj["PRListComparison"][j]
          );
          obj["PRListComparison"][j]["PilihanBeli"] =
            "" + JSON.parse(obj["PRListComparison"][j]["PilihanBeli"]);
        }
        obj["PurchaseRequisitionID"] = params.transid;
        newValues.push(obj);
      }
    }
    mutationSave.mutate(newValues);
    mutationUpdate.mutate({
      PRCApprovalID: params.PRCApprovalID,
      Approved: type,
      PRComparisonInsert: newValues,
    });
  };

  function prEditor(name, ids, e) {
    var temp = pRListComparison;
    temp[ids][name] = e;
    setPRListComparison([...temp]);
  }

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col  mt-5">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() =>
                      navigate("/procurment/report/price-comparison")
                    }
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>

                  <button
                    onClick={() => Kirim(2)}
                    className="bg-red-400 flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    {mutationAdd.isLoading ? (
                      <>
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline mr-3 w-4 h-4 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="current
                                       Color"
                          />
                        </svg>
                        Loading
                      </>
                    ) : (
                      "Tolak"
                    )}
                  </button>
                </div>
                <div className="w-1/3"></div>
                {PurchaseRequisition.data ? (
                  <>
                    <div className={"row-auto"}>
                      <div className={"w-full md:w-1/3 px-3 mb-5"}>
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                          No. PR
                        </label>
                        <Select
                          value={prData.filter(
                            ({ value }) =>
                              value === values["PurchaseRequisitionID"]
                          )}
                          isDisabled={true}
                          name={"PurchaseRequisitionID"}
                          className={
                            (touched["PurchaseRequisitionID"] ||
                              buttonTouched) &&
                            errors["PurchaseRequisitionID"]
                              ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                              : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500"
                          }
                          onChange={(text) =>
                            PRHandler(text.value, "PurchaseRequisitionID")
                          }
                          options={prData}
                        />
                      </div>
                      {prData[values["PurchaseRequisitionID"]] && (
                        <div className={"w-full md:w-1/3 px-3 mb-5"}>
                          <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                            Tanggal
                          </label>
                          <div
                            className={
                              "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                            }
                          >
                            {new Date(
                              prData[values["PurchaseRequisitionID"]]["DatePR"]
                            )
                              .toISOString()
                              .substring(0, 10)}
                          </div>
                        </div>
                      )}
                      {prData[values["PurchaseRequisitionID"]] && (
                        <div className={"w-full md:w-1/2 px-3 mb-5"}>
                          <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                            Remarks
                          </label>
                          <div
                            className={
                              "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                            }
                          >
                            {prData[values["PurchaseRequisitionID"]]["Remarks"]}
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <button className="w-full md:w-1/3 px-3 mb-5 bg-main-100 p-2">
                    <svg
                      aria-hidden="true"
                      role="status"
                      className="inline mr-3 w-4 h-4 text-white animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="current
                                       Color"
                      />
                    </svg>
                    Loading
                  </button>
                )}
                <div className="w-1/4">
                  <HrdInputGenerator
                    type={"number"}
                    value={values}
                    name={"SupplierCount"}
                    title={"Jumlah Supplier"}
                    onChange={SupplierCount}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <hr />
                {PurchaseRequisitionDetail.isLoading ? (
                  <Skeltons />
                ) : (
                  <DynamicTableSimple
                    data={barang}
                    header={header}
                    OnClick={ModalOpener}
                    name={"Purchase Requisition"}
                    barang={barangDetail.data}
                  />
                )}

                <hr className={"my-5"} />

                <div className="mb-4 border-b border-gray-200 dark:border-gray-700">
                  <ul
                    className="flex flex-wrap -mb-px text-sm font-medium text-center"
                    id="myTab"
                    data-tabs-toggle="#myTabContent"
                    role="tablist"
                  >
                    {<SupplierBuilder />}
                    <li key={-1} className="mr-2" role="presentation">
                      <button
                        onClick={() => {
                          setSupplierSelected(-1);
                        }}
                        className={
                          supplierSelected === -1
                            ? "inline-block p-4 rounded-t-lg border-b-2 text-main-100 border-main-100 bg-gray-200"
                            : "inline-block p-4 rounded-t-lg border-b-2 "
                        }
                        type="button"
                        role="tab"
                        aria-selected="false"
                      >
                        Komparasi
                      </button>
                    </li>
                    <li key={"Show hide"} className="mr-2" role="presentation">
                      <button
                        className="inline-block p-4 rounded-t-lg border-b-2 bg-main-100 "
                        onClick={(e) => setshowDetail(!showDetail)}
                      >
                        {showDetail ? "Hide" : "Show"} Supplier Data
                      </button>
                    </li>
                  </ul>
                  {PurchaseRequisitionDetail.isLoading ? (
                    <Skeltons />
                  ) : (
                    <>
                      {pRListComparison &&
                        pRListComparison.map((cats, ids) => {
                          if (ids === supplierSelected - 1) {
                            return (
                              <div key={"Main" + ids} className={"mt-10"}>
                                {showDetail && (
                                  <div className={"text-left items-start"}>
                                    <div className="grid gap-6 mb-6 md:grid-cols-3 px-3 my-4">
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Name
                                        </label>
                                        {supplier.data && (
                                          <Select
                                            value={supplier.data.data.filter(
                                              ({ value }) =>
                                                value === cats["NamaSupplier"]
                                            )}
                                            name={"NamaSupplier"}
                                            className={
                                              "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 "
                                            }
                                            isDisabled={true}
                                            options={supplier.data.data}
                                          />
                                        )}

                                        {/* <input
                                                                            type="text"
                                                                            value={cats["NamaSupplier"]}
                                                                            name={"NamaSupplier"}
                                                                            disabled={true}
                                                                            className={"appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"}
                                                                            onChange={(e) => {
                                                                                prEditor("NamaSupplier", ids, e.target.value);
                                                                            }}
                                                                        /> */}
                                      </div>
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Tanggal Kirim
                                        </label>
                                        <DatePicker
                                          utcOffset={0}
                                          dateFormat="dd/MMMM/yyyy"
                                          timeFormat={"dd/MMMM/yyyy "}
                                          disabled={true}
                                          selected={
                                            new Date(cats["TanggalKirim"])
                                          }
                                          className={
                                            "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                          }
                                          onChange={(text) =>
                                            prEditor("Currency", ids, text)
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="grid gap-6 mb-6 md:grid-cols-3 px-3 my-4">
                                      <div>
                                        <label className="block mb-2 text-sm font-medium text-gray-900 uppercase">
                                          Franco
                                        </label>
                                        {franco.data && (
                                          <Select
                                            value={franco.data.data.filter(
                                              ({ value }) =>
                                                value === cats["FrancoID"]
                                            )}
                                            isDisabled={true}
                                            name={"FrancoID"}
                                            className={
                                              "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500"
                                            }
                                            onChange={(text) =>
                                              prEditor(
                                                "FrancoID",
                                                ids,
                                                text.value
                                              )
                                            }
                                            options={franco.data.data}
                                          />
                                        )}
                                      </div>

                                      <div>
                                        <label className="block mb-2 text-sm font-medium text-gray-900 uppercase">
                                          TOP
                                        </label>
                                        <Select
                                          value={Top.filter(
                                            ({ value }) => value === cats["TOP"]
                                          )}
                                          isDisabled={true}
                                          name={"TOP"}
                                          className={
                                            "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500"
                                          }
                                          onChange={(text) =>
                                            prEditor("TOP", ids, text.value)
                                          }
                                          options={Top}
                                        />
                                      </div>
                                      <div>
                                        <label className="block mb-2 text-sm font-medium text-gray-900 uppercase">
                                          Currency
                                        </label>
                                        <Select
                                          value={Currency.filter(
                                            ({ value }) =>
                                              value === cats["Currency"]
                                          )}
                                          isDisabled={true}
                                          name={"Currency"}
                                          className={
                                            "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500"
                                          }
                                          onChange={(text) =>
                                            prEditor(
                                              "Currency",
                                              ids,
                                              text.value
                                            )
                                          }
                                          options={Currency}
                                        />
                                      </div>
                                    </div>
                                    <div className="grid gap-6 mb-6 md:grid-cols-3 px-3 my-4">
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Discound %
                                        </label>
                                        <input
                                          disabled={true}
                                          type="number"
                                          max={100}
                                          value={cats["DiscountPercent"]}
                                          name={"DiscountPercent"}
                                          className={
                                            "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                          }
                                          onChange={(e) => {
                                            prEditor(
                                              "DiscountPercent",
                                              ids,
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Discound Rp
                                        </label>
                                        <input
                                          disabled={true}
                                          type="number"
                                          value={cats["DiscountRupiah"]}
                                          name={"DiscountRupiah"}
                                          className={
                                            "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                          }
                                          onChange={(e) => {
                                            prEditor(
                                              "DiscountRupiah",
                                              ids,
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="grid gap-6 mb-6 md:grid-cols-3 px-3 my-4">
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          PPN %
                                        </label>
                                        <input
                                          disabled={true}
                                          type="number"
                                          max={100}
                                          value={cats["PPN"]}
                                          name={"PPN"}
                                          className={
                                            "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                          }
                                          onChange={(e) => {
                                            prEditor(
                                              "PPN",
                                              ids,
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          PPH %
                                        </label>
                                        <input
                                          disabled={true}
                                          type="number"
                                          max={100}
                                          value={cats["PPH"]}
                                          name={"PPH"}
                                          className={
                                            "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                          }
                                          onChange={(e) => {
                                            prEditor(
                                              "PPH",
                                              ids,
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>

                                    {/* Biaya Lain-lain: nominal di LUAR biaya utama (setelah pajak) */}
                                    <div className="grid gap-6 mb-6 px-3 my-4 md:grid-cols-2">
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Biaya Lain-lain (nominal)
                                        </label>
                                        <input
                                          disabled
                                          readOnly
                                          type="text"
                                          value={(parseFloat(cats["BiayaLain"]) || 0).toLocaleString("in-ID", { maximumFractionDigits: 2 })}
                                          name={"BiayaLain"}
                                          className="appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        />
                                      </div>
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Keterangan Biaya Lain-lain
                                        </label>
                                        <input
                                          disabled
                                          readOnly
                                          type="text"
                                          value={cats["KeteranganBiayaLain"] || "-"}
                                          name={"KeteranganBiayaLain"}
                                          className="appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        />
                                      </div>
                                    </div>

                                    <div className="grid gap-6 mb-6 px-3 my-4">
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Term of condition
                                        </label>
                                        <textarea
                                          type="text"
                                          value={cats["TOC"]}
                                          name={"TOC"}
                                          className={
                                            "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500 h-20"
                                          }
                                          onChange={(e) => {
                                            prEditor(
                                              "TOC",
                                              ids,
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                    {cats["NamaFile"] && (
                                      <div className="grid gap-6 mb-6 px-3 my-4">
                                        <div className="w-1/2">
                                          <label className="block uppercase  tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Data pendukung terupload *
                                          </label>

                                          <a
                                            onClick={() =>
                                              getDataFromURL(cats["NamaFile"])
                                            }
                                            className="flex flex-row  mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                          >
                                            <BiPrinter className="text-xl text-gray-800 mr-2" />
                                            <span>{cats["NamaFile"]}</span>
                                          </a>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                                <table className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10">
                                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                                    <tr>
                                      <th
                                        scope="col"
                                        className="py-3 px-6"
                                        rowSpan={2}
                                      >
                                        Barang
                                      </th>
                                      <th
                                        scope="col"
                                        className="py-3 px-6"
                                        rowSpan={2}
                                      >
                                        Harga
                                      </th>
                                      <th
                                        scope="col"
                                        className="py-3 px-6 text-center border-b"
                                        colSpan={2}
                                      >
                                        Discound
                                      </th>

                                      <th
                                        scope="col"
                                        className="py-3 px-6"
                                        rowSpan={2}
                                      >
                                        Merk
                                      </th>
                                      <th
                                        scope="col"
                                        className="py-3 px-6"
                                        rowSpan={2}
                                      >
                                        Total Harga
                                      </th>
                                      <th
                                        scope="col"
                                        className="py-3 px-6"
                                        rowSpan={2}
                                      >
                                        Pilihan Beli
                                      </th>
                                    </tr>
                                    <tr>
                                      <th
                                        scope="col"
                                        className="py-3 px-6 text-center"
                                      >
                                        %
                                      </th>
                                      <th
                                        scope="col"
                                        className="py-3 px-6 text-center"
                                      >
                                        Rp
                                      </th>
                                    </tr>
                                  </thead>

                                  <>
                                    {cats["PRListComparison"] &&
                                      cats["PRListComparison"].map(
                                        (detail, id) => {
                                          let classOdd =
                                            "bg-gray-50 border-b  hover:bg-gray-200 hover:text-main-100";
                                          if (id % 2 === 0)
                                            classOdd =
                                              "bg-white border-b  hover:bg-gray-200 hover:text-main-100";
                                          const texts = detail.NamaBarang
                                            ? `${detail.BarangID} - ${detail.NamaBarang}`
                                            : detail.BarangID || "";
                                          return (
                                            <tr
                                              key={
                                                id + "rows" + supplierSelected
                                              }
                                              className={classOdd}
                                            >
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowt" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                {texts}
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowHarga" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="number"
                                                  value={detail["Harga"]}
                                                  name={"Harga"}
                                                  disabled={true}
                                                  className={
                                                    "appearance-none block w-full text-right text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rownumber" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="number"
                                                  value={
                                                    detail["DiscountPercent"]
                                                  }
                                                  max={"100"}
                                                  disabled={true}
                                                  name={"DiscountPercent"}
                                                  className={
                                                    "appearance-none block w-full text-right text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rownumbers" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="number"
                                                  disabled={true}
                                                  value={
                                                    detail["DiscountRupiah"]
                                                  }
                                                  name={"DiscountRupiah"}
                                                  className={
                                                    "appearance-none block w-full text-right text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowMerk" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="text"
                                                  disabled={true}
                                                  value={detail["Merk"]}
                                                  name={"Merk"}
                                                  className={
                                                    "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowTotalHarga" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap text-right"
                                                }
                                              >
                                                {parseFloat(
                                                  detail["TotalHarga"]
                                                ).toLocaleString("in-ID", {
                                                  maximumFractionDigits: 2,
                                                })}
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowPilihanBeli" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="checkbox"
                                                  value={true}
                                                  checked={
                                                    detail["PilihanBeli"]
                                                  }
                                                  disabled={true}
                                                  name={"PilihanBeli"}
                                                  className={
                                                    "w-4 h-4 text-main-100 bg-gray-100 rounded border-main-100"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                            </tr>
                                          );
                                        }
                                      )}
                                    <>
                                      {/* PERUBAHAN: Ganti label dan tukar posisi nilai */}
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          Total{" "}
                                          {/* Ganti dari "Total 1" menjadi "Total" */}
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["Total"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          Discound{" "}
                                          {/* Ganti dari "Discound" menjadi "Grand Total" */}
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {/* PERUBAHAN: Nilai yang sebelumnya di Total2 sekarang di sini (nilai setelah discount) */}
                                          {parseFloat(
                                            cats["Discount"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          Grand Total{" "}
                                          {/* Ganti dari "Total 2" menjadi "Discound" */}
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {/* PERUBAHAN: Nilai yang sebelumnya di Discound sekarang di sini (nilai discount) */}
                                          {parseFloat(
                                            cats["GrandTotal"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          PPN
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["PPNTotal"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          PPH
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["PPHTotal"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          PBBKB
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["PBBKBTotal"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      {parseFloat(cats["BiayaLain"] || 0) > 0 && (
                                        <tr className={"table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"}>
                                          <th scope="row" colSpan={5} className={"py-4 px-6 font-medium whitespace-nowrap text-right"}>
                                            Biaya Lain-lain{cats["KeteranganBiayaLain"] ? ` (${cats["KeteranganBiayaLain"]})` : ""}
                                          </th>
                                          <th scope="row" className={"py-4 px-6 font-medium whitespace-nowrap text-right"}>
                                            {parseFloat(cats["BiayaLain"] || 0).toLocaleString("in-ID", { maximumFractionDigits: 2 })}
                                          </th>
                                          <th scope="row" className={"py-4 px-6 font-medium whitespace-nowrap "}></th>
                                        </tr>
                                      )}
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          Total Final
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["GTOTAL"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                    </>
                                  </>
                                </table>
                              </div>
                            );
                          }
                        })}
                      {supplierSelected === -1 && (
                        <div key={"Main-1"} className={"mt-10 overflow-x-auto"}>
                          <table className="table-auto w-full text-sm text-left text-gray-500 mt-10">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                              {/* Header row 1: fixed cols + per-supplier group label */}
                              <tr>
                                <th className="py-3 px-6" rowSpan={2}>Barang</th>
                                <th className="py-3 px-6" rowSpan={2}>Qty</th>
                                {pRListComparison && pRListComparison.map((cats, ids) => (
                                  <th
                                    key={"sup-hdr-" + ids}
                                    scope="col"
                                    className="py-3 px-6 text-center border-b border-l"
                                    colSpan={6}
                                  >
                                    Supplier {ids + 1}
                                    {cats["NamaSupplier"] ? ` — ${cats["NamaSupplier"]}` : ""}
                                  </th>
                                ))}
                              </tr>
                              {/* Header row 2: per-supplier sub-columns */}
                              <tr>
                                {pRListComparison && pRListComparison.map((_, ids) => (
                                  <React.Fragment key={"sub-hdr-" + ids}>
                                    <th className="py-3 px-4 border-l">Harga</th>
                                    <th className="py-3 px-4">Disc %</th>
                                    <th className="py-3 px-4">Disc Rp</th>
                                    <th className="py-3 px-4">Merk</th>
                                    <th className="py-3 px-4 text-right">Total</th>
                                    <th className="py-3 px-4 text-center">Pilihan</th>
                                  </React.Fragment>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {/* Body: loop by product index, then by supplier */}
                              {pRListComparison &&
                                pRListComparison[0]?.PRListComparison?.map((_, productIndex) => {
                                  const firstItem = pRListComparison[0].PRListComparison[productIndex];
                                  const namaBarang = firstItem?.NamaBarang
                                    ? `${firstItem.BarangID} - ${firstItem.NamaBarang}`
                                    : firstItem?.BarangID || "";
                                  const rowClass = productIndex % 2 === 0
                                    ? "bg-white border-b hover:bg-gray-50"
                                    : "bg-gray-50 border-b hover:bg-gray-100";
                                  return (
                                    <tr key={"row-" + productIndex} className={rowClass}>
                                      <td className="py-3 px-6 font-medium whitespace-nowrap">{namaBarang}</td>
                                      <td className="py-3 px-6 text-right whitespace-nowrap">
                                        {`${firstItem?.Qty || 0} ${satuanBarang(firstItem?.BarangID)}`.trim()}
                                      </td>
                                      {pRListComparison.map((cats, supplierIdx) => {
                                        const detail = cats.PRListComparison?.[productIndex];
                                        if (!detail) return <React.Fragment key={"empty-" + supplierIdx}><td colSpan={6} /></React.Fragment>;
                                        return (
                                          <React.Fragment key={"sup-data-" + supplierIdx}>
                                            <td className="py-3 px-4 border-l text-right">
                                              {parseFloat(detail.Harga || 0).toLocaleString("id-ID", { maximumFractionDigits: 2 })}
                                            </td>
                                            <td className="py-3 px-4 text-right">
                                              {parseFloat(detail.DiscountPercent || 0).toLocaleString("id-ID", { maximumFractionDigits: 2 })}
                                            </td>
                                            <td className="py-3 px-4 text-right">
                                              {parseFloat(detail.DiscountRupiah || 0).toLocaleString("id-ID", { maximumFractionDigits: 2 })}
                                            </td>
                                            <td className="py-3 px-4">{detail.Merk || "-"}</td>
                                            <td className="py-3 px-4 text-right">
                                              {parseFloat(detail.TotalHarga || 0).toLocaleString("id-ID", { maximumFractionDigits: 2 })}
                                            </td>
                                            <td className="py-3 px-4 text-center">
                                              <input
                                                type="checkbox"
                                                checked={!!detail.PilihanBeli}
                                                disabled={true}
                                                readOnly
                                                className="w-4 h-4 text-main-100 bg-gray-100 rounded border-main-100"
                                              />
                                            </td>
                                          </React.Fragment>
                                        );
                                      })}
                                    </tr>
                                  );
                                })
                              }
                            </tbody>
                          </table>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewPurchaseComparationPage;
